import { useMount } from "react-use";
import { useIncode } from "./IncodeContext";

export const ProcessId = () => {
  const { incode, token, navigateTo, track } = useIncode();
  useMount(async () => {
    try {
      await incode.processId({ token });
      track("process_id_success");
      navigateTo("tutorial_selfie");
    } catch {
      track("process_id_error");
      navigateTo("tutorial_selfie");
    }
  });

  return null;
};
